/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 14th 2022, 12:05:49 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSActionButton } from "ui-widgets";
import { IconButton } from "@mui/material";
import { UserPlus, IconProps } from "react-feather";
import { InviteWorkersButtonWrapper } from "./InviteWorkersButtonWrapper";
import { useTranslatedText } from "core/locales/useTranslatedText";

export const InviteWorkersIcon = (iconProps: IconProps) => {
  // Example Usage: <InviteWorkersIcon color={COLORSCHEME.secondaryVariant} />
  // Wrap it with the InviteWorkersButtonWrapper to get invitate worker functionality.

  return (
    <IconButton>
      <UserPlus {...iconProps} />
    </IconButton>
  );
};

export const InviteWorkersButton = () => {
  const LANG = useTranslatedText();

  return (
    <InviteWorkersButtonWrapper>
      <OSActionButton actionStyle="manage-accounts">{LANG.inviteWorkers}</OSActionButton>
    </InviteWorkersButtonWrapper>
  );
};
